<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px"
>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint')}}
        </template>
    
    </v-data-table>

    <m-icon-bar
        v-on:add="onClickCreateOptOut"
    />

    <m-create-bulk-opt-out-dialog
        ref="bulk-opt-out-dialog"
        v-on:upsert_bulk_opt_out="update()"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            results: [],

            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time'},
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'Name', value: 'full_name'},
                { text: 'Category', value: 'category'},
                { text: 'State', value: 'state'},
                { text: 'By Team Member', value: 'by_employee_label'},
                { text: 'Specimen', value: 'specimen'},
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/consent/records',
            
                {
                    'organization_id': this.$route.params.organization_id,
                    'endpoint' : this.$route.params.endpoint,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickCreateOptOut()
        {
            this.$refs['bulk-opt-out-dialog'].showDialog(
                this.$route.params.organization_id,
                this.$route.params.endpoint
            );
        },
    },

    computed: {
        title() {
            return this.$rc.pretty(this.$route.params.endpoint, 'endpoint')+' Consent Details';
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>